import React from "react";
import { resolveCmsAsset } from "../../cms/media";

export default function ImageRowBlock({ id, type, images = [] }) {
  if (!images.length) return null;

  return (
    <div className="container py-3">
      <div className="row g-3 d-none d-md-flex">
        {images.map((img) => (
          <div className="col-12 col-md-4" key={img.src}>
            <picture>
              <img
                className="img-fluid rounded shadow-sm"
                src={resolveCmsAsset(img.src)}
                alt={img.alt || ""}
              />
            </picture>
          </div>
        ))}
      </div>
    </div>
  );
}
